import React from 'react';
import clsx from 'clsx';
import { feeDataTypes } from '../../store/merchnts/merchant-context-variables';
import { IFees } from '../../store/merchnts/merchant-interfaces';

export const BusinessSettingsFeesTableRow = ({ amount, name, minimumFeeAmount }:IFees):JSX.Element => {
	return (
		<tr>
			<td className="w-150px">{name}</td>
			<td className="py-7">
				<div className={clsx('fee-input-container')}>
					{name !== feeDataTypes.PERCENTAGE && <div>$</div>}
					<input
						type="number"
						className="number-input"
						step="1"
						lang="en"
						placeholder="0.00"
						value={amount ? amount : null}
						disabled
					/>
					<div>
						{name !== feeDataTypes.PERCENTAGE ? 'USD' : '%'}
					</div>
				</div>
			</td>
			<td>
				{
					minimumFeeAmount === ''
						? <div>-</div>
						: (
							<div className={clsx('fee-input-container')}>
								<div>$</div>
								<input
									type="number"
									className="number-input"
									step="1"
									lang="en"
									value={minimumFeeAmount}
									disabled
								/>
								<div>USD</div>
							</div>
						)
				}
			</td>
		</tr>
	);
};
